import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { BREAKPOINTS } from '../../lib/constants';

export const Header = styled.h1`
  margin: 0;
  font-weight: ${fromTheme('font_weight_bolder')};
  font-size: ${fromTheme('font_size_heading_3')};
  color: ${fromTheme('color_text')};

  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    font-size: ${fromTheme('font_size_heading_2')};
  }

  @media screen and (min-width: ${BREAKPOINTS.medium}px) {
    font-size: ${fromTheme('font_size_heading_1')};
  }
`;
